import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { IdTokenClaims } from '@azure/msal-common'
import { LocalStorageService } from 'framework/localstorage.service';
import { Router } from '@angular/router';
import { AuthyService } from './authy.service';
import { jwtDecode } from 'jwt-decode';
import { SharedService } from 'app/shared/services/shared.service';

declare var $: any;

type IdTokenClaimsWithPolicyId = IdTokenClaims & {
  acr?: string,
  tfp?: string,
};

type LinkPolicyType = 'signin' | 'password-reset';


@Component({
  selector: 'app-authy',
  templateUrl: './authy.component.html',
  styleUrls: ['./authy.component.css']
})
export class AuthyComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  isIframe = false;
  loading = false;

  isLoggedIn = false;
  displayName = '';

  constructor(
    @Inject(MsalService) private authService: MsalService,
    @Inject(MsalBroadcastService) private msalBroadcastService: MsalBroadcastService,
    private authyService: AuthyService, private shareService: SharedService,
    private localStorage: LocalStorageService,private _router: Router
  ) {
  }

  ngOnInit(): void {
    $('#plsWaitOnIAgreeModal').modal('show');
    console.log('loading');

    // // initializes MSAL and configures redirect route.
     this.authService.handleRedirectObservable().subscribe();
     
    // get the invite
    const inviteKey = this.localStorage.getItem("invite_key");
    let authyPrefValue = this.localStorage.getItem("authy_pref_value");
    let that = this;
    this.authyService.getInviteIdToken(inviteKey).subscribe({
      next: (response) => {
        const action = response['action'];
        const token = response['idToken'];
        const email = response['email'];
        const clientColor = response['clientColor'];
        const clientLogoUrl = response['clientLogoUrl'];
        const clientLocale = this.localStorage.getItem("authy_locale");
        let extraQueryParameters: Record<string, string> = {};
        let state: string | undefined = undefined;
        state = `client_info=${window.btoa(
          JSON.stringify({
            color: clientColor,
            logo: clientLogoUrl,
            invite: inviteKey,
            locale: clientLocale
          })
        )}`;
        if (token) {
          // if there is a token provide it, it will have everything it needs
          extraQueryParameters = { id_token_hint: token };
        } else {
          // if it's not, all the non invite policies support invite, login hint, clientColor, and clientLogoUrl as query parameters
          // if the invite is provided it will be sent back in the id token. However, V2 no longer stores the invite id with the user.
          extraQueryParameters = {
            invite: inviteKey,
            clientColor: encodeURIComponent(clientColor),
            clientLogoUrl: encodeURIComponent(clientLogoUrl),
          };
        }
        if (authyPrefValue === "4" && action === 'signin') {
          authyPrefValue = "1";
        }
        that.shareService.logFlow("authy","get-authy-token");     
        let mfaType = that.shareService.getMfaType(authyPrefValue);
        const authority = environment.invitePolicies[action][mfaType];
        this.authService.loginRedirect({
          authority,
          scopes: environment.scopes,
          prompt: 'login',
          loginHint: token ? undefined : email,
          extraQueryParameters: {
            ...extraQueryParameters,
            ui_locales: encodeURIComponent(clientLocale),
          },
          state
        });
        $('#plsWaitOnIAgreeModal').modal('hide');
      },
      error: () => {
        $('#plsWaitOnIAgreeModal').modal('hide');
        this._router.navigate(['./invalid']);
      },
    });
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


}